<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
    <z-page title="Carian Laporan BSE">
      <div class="table_scrol">
         <div class="w-card__content content-hardcode mb3">
          <w-form v-model="valid" @validate="cari" ref="frm">

            <w-flex class="mt3 filter-row">
                <div class="filter-col" v-if="!$zutil.role('1')">
                   <b> Negeri : {{negeri_user.nama ?? ''}}</b>
                </div>
                <div class="filter-col" v-if="$zutil.role('1')">
                    <w-select class="mt4 role-selector" :items="negeri" v-model="pencarian.lkp_negeri_id" @input="getDaerah(pencarian.lkp_negeri_id)" label="Negeri" placeholder="-----SEMUA-----" outlined color="primary" large dark v-if="$zutil.role('1')" />

                    <!-- <z-select style="margin:5px;" :items="negeri" label="Negeri"  v-model="pencarian.lkp_negeri_id"  @input="getDaerah(pencarian.lkp_negeri_id)" v-if="$zutil.role('1') || $zutil.role('2') || $zutil.role('5')"/> -->
               </div>
            </w-flex>
            <br>

            <w-flex class="mt3 filter-row">
                <div class="filter-col">
                    <z-select style="margin:5px;" :items="daerah" class="mt4" label="Daerah"  v-model="pencarian.lkp_daerah_id" />
                </div>
                <div class="filter-col">
                    <z-select style="margin:5px; " v-model="pencarian.premis_id" :items="premis" label="ID Premis" />
                </div>
                <div class="filter-col">
                    <z-select style="margin:5px;" v-model="pencarian.lkp_tujuan_id" :items="lkp_tujuan" label="Tujuan BSE"/>
                </div>
            </w-flex>


            <w-flex class="mt3 filter-row">
                <div class="filter-col">
                    <z-select style="margin:5px; "  class="mt4" :items="lkp_ternakan" label="Jenis Ternakan"  v-model="pencarian.lkp_ternakan_id"/> 
                </div>
                <div class="filter-col">
                    <w-input 
                        label="Tarikh Permohonan Dari" 
                        type="date" 
                        v-model="pencarian.tarikh_dari"
                    />
                </div>
                <div class="filter-col">
                    <w-input 
                        label="Tarikh Permohonan Hingga" 
                        type="date" 
                        v-model="pencarian.tarikh_hingga"
                    />
                </div>
            </w-flex>
          </w-form>
          <br>
          <w-flex justify-end class="mt2">
              <w-button class="mr2" v-on:click="resetPencarian()" bg-color="warning">
                  <w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA</w-button>
              <w-button class="mr2" bg-color="primary" @click="$refs.frm.validate()">
                  <w-icon>fal fa-search</w-icon>&nbsp;CARI
              </w-button>
          </w-flex>
        </div>
         <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'SENARAI LAPORAN BSE'">
          <template #title>
            SENARAI LAPORAN BSE
          </template>
            <w-flex justify-end class="mt2">
                <w-button bg-color="success" v-on="on" @click="createExcel()" class="mr2">
                    <w-icon class="mr1" md >fal fa-download</w-icon>Muat Turun Excel
                </w-button>
            </w-flex>
            <br>
          <div class="w-table-wrap" style="max-height: 900px;">
            
            <div class="table-profil-scrol">
              <br><br>
              <table class="w-table" color="light" style="border:1px">
                <thead>
                  <tr>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">BIL</th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">NEGERI</th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">DAERAH</th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">ID/NAMA PREMIS</th>
                     <!-- <th class="w-table__header text-center" style="border: 1px solid #000;">NO PERMOHONAN</th> -->
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">TUJUAN FE</th>
                     <!-- <th class="w-table__header text-center" style="border: 1px solid #000;">TARIKH PERMOHONAN</th> -->
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">TARIKH TEMUJANJI</th>
                     <!-- <th class="w-table__header text-center" style="border: 1px solid #000;">TARIKH CHECK-IN</th>
                     <th class="w-table__header text-center" style="border: 1px solid #000;">NO PENDAFTARAN</th> -->
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">ID | NAMA TERNAKAN</th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">JENIS TERNAKAN</th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">BAKA</th>
                     <!-- <th class="w-table__header text-center" style="border: 1px solid #000;">UMUR (BULAN)</th> -->
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">BILANGAN PEMERIKSAAN</th>
                     <!-- <th class="w-table__header text-center" style="border: 1px solid #000;">TARIKH PEMERIKSAAN TERAKHIR</th>
                     <th class="w-table__header text-center" style="border: 1px solid #000;">PASUNG</th>

                    <th class="w-table__header text-center" style="border:1px solid #000;">SKOR BADAN</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">BERAT</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">TANDA PENYAKIT KLINIKAL</th>

                    <th class="w-table__header text-center" style="border:1px solid #000;">LOCOMOTOR</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">POSTUR KAKI</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">POSTUR BADAN</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">LIBIDO</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">KAEDAH PEMUNGUTAN SEMEN</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">ISIPADU (ML)</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">WARNA SEMEN</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">KEPEKATAN SEMEN</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">SKOR MASSA</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">MOTILITI HIDUP</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">MOTILITI PROGRESIF</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">KECACATAN SEMENING</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">TESTIS</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">EPIDIDYMIS</th>
                    

                    <th class="w-table__header text-center" style="border:1px solid #000;">KORDA SPERMATIK</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">PREPUCE / PENIS</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">SKOR KEKENYALAN TESTIS</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">UKURLILIT SKROTUM</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">AMPULLAE</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">KELENJAR VESIKAL</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">KELENJAR PROSTAT</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">SIFAT TERNAKAN</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">BRUCELLOSIS</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">FMD</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">TRICHOMONIASIS</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">CAMPYLOBACTERIOSIS</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">LEPTOSPIROSIS</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">TUBERCULOSIS</th> -->
                    <th class="w-table__header text-center" style="border:1px solid #000; background:#d6e4f5;">STATUS PEMERIKSAAN</th>
                  </tr>
                </thead>
                <tbody>
                    <template v-if="items.data.length == 0">
                        <tr class="w-table__row" >
                            <td class="w-table__cell text-center" colspan="10"> Tiada Data.</td>
                        </tr>
                    </template>
                  <template  v-for="(dt, ind) in items.data" :key="dt.id">

                    <tr class="w-table__row">
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                        {{ (items.current_page - 1) * items.per_page + ind + 1 }}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.lkp_negeri ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.lkp_daerah ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.no_premis ?? '-'}} | {{dt.nama_premis ?? '-'}}</td>
                        <!-- <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.no_permohonan ?? '-'}}</td> -->
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.tujuan_fe ?? '-'}}</td>
                        <!-- <td class="w-table__cell text-left" style="border: 1px solid #000;">{{$zutil.dateformat(dt.tarikh_mohon)}}</td> -->
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{$zutil.dateformat(dt.tarikh_temujanji)}}</td>
                        <!-- <td class="w-table__cell text-left" style="border: 1px solid #000;">{{$zutil.dateformat(dt.tarikh_checkin)}}</td> -->
                        <!-- <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.kode ?? '-'}}</td> -->
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.id_ternakan ?? '-'}} | {{dt.nama_ternakan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.jenis_ternakan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.lkp_baka ?? '-'}}</td>
                        <!-- <td class="w-table__cell text-left" style="border: 1px solid #000;">{{$zutil.umurbulan(dt.tarikh_lahir)}}</td> -->
                        <td class="w-table__cell text-center" style="border: 1px solid #000;">{{dt.bilangan_pemeriksaan ?? '-'}}</td>
                        <!-- <td class="w-table__cell text-left" style="border: 1px solid #000;">{{$zutil.dateformat(dt.tarikh_pemeriksaan)}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                            <template v-if="dt.pasung == 1"> Ya</template>
                            <template v-else>Tidak</template>
                        </td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.skor_badan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.berat_badan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                            <template v-if="dt.tanda_klinikan == 1"> Ya</template>
                            <template v-else>Tidak</template>
                        </td>


                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                            <template v-if="dt.locomotor == 1"> Normal</template>
                            <template v-else-if="dt.locomotor == 2">Abnormal</template>
                        </td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                            <template v-if="dt.kaki == 1"> Normal</template>
                            <template v-else-if="dt.kaki == 2">Abnormal</template>
                        </td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                            <template v-if="dt.badan == 1"> Normal</template>
                            <template v-else-if="dt.badan == 2">Abnormal</template>
                        </td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.skor_libido ?? '-'}}</td>

                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                            <template v-if="dt.kaedah_pungutan == 1"> Palpasi Rektal</template>
                            <template v-else-if="dt.kaedah_pungutan == 2">Elektroejakulasi</template>
                            <template v-else-if="dt.kaedah_pungutan == 3">Vaginal Tiruan</template>
                        </td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.isipadu ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.warna ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.kepekatan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.motiliti ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.motiliti_hidup ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.motiliti_progresif ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                            <template v-if="dt.kecacatan == 1"> Ya</template>
                            <template v-else>Tidak</template>
                        </td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                            <template v-if="dt.testis == 1"> Normal</template>
                            <template v-else-if="dt.testis == 2">Abnormal</template>
                        </td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                            <template v-if="dt.epididymis == 1"> Normal</template>
                            <template v-else-if="dt.epididymis == 2">Abnormal</template>
                        </td>


                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                            <template v-if="dt.korda == 1"> Normal</template>
                            <template v-else-if="dt.korda == 2">Abnormal</template>
                        </td>

                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                            <template v-if="dt.penis == 1"> Normal</template>
                            <template v-else-if="dt.penis == 2">Abnormal</template>
                        </td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.kekenyalan_testis ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.skortum ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                            <template v-if="dt.ampullae == 1"> Normal</template>
                            <template v-else-if="dt.ampullae == 2">Abnormal</template>
                        </td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                            <template v-if="dt.vesikal == 1"> Normal</template>
                            <template v-else-if="dt.vesikal == 2">Abnormal</template>
                        </td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                            <template v-if="dt.prostat == 1"> Normal</template>
                            <template v-else-if="dt.prostat == 2">Abnormal</template>
                        </td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                            <template v-if="dt.sifat_ternakan == 1"> Jinak</template>
                            <template v-else-if="dt.sifat_ternakan == 2">Agresif</template>
                        </td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                            <template v-if="dt.brucellosis == 1"> Positif</template>
                            <template v-else-if="dt.brucellosis == 2">Negatif</template>
                            <template v-else>Belum di uji</template>
                        </td>
                         <td class="w-table__cell text-left" style="border: 1px solid #000;">
                            <template v-if="dt.fmd == 1"> Positif</template>
                            <template v-else-if="dt.fmd == 2">Negatif</template>
                            <template v-else>Belum di uji</template>
                        </td>
                         <td class="w-table__cell text-left" style="border: 1px solid #000;">
                            <template v-if="dt.trichomoniasis == 1"> Positif</template>
                            <template v-else-if="dt.trichomoniasis == 2">Negatif</template>
                            <template v-else>Belum di uji</template>
                        </td>
                         <td class="w-table__cell text-left" style="border: 1px solid #000;">
                            <template v-if="dt.campylobacteriosis == 1"> Positif</template>
                            <template v-else-if="dt.campylobacteriosis == 2">Negatif</template>
                            <template v-else>Belum di uji</template>
                        </td>
                         <td class="w-table__cell text-left" style="border: 1px solid #000;">
                            <template v-if="dt.leptospirosis == 1"> Positif</template>
                            <template v-else-if="dt.leptospirosis == 2">Negatif</template>
                            <template v-else>Belum di uji</template>
                        </td>
                         <td class="w-table__cell text-left" style="border: 1px solid #000;">
                            <template v-if="dt.tuberculosis == 1"> Positif</template>
                            <template v-else-if="dt.tuberculosis == 2">Negatif</template>
                            <template v-else>Belum di uji</template>
                        </td> -->
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.status_pemeriksaan ?? '-'}}</td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <br><br>

            </div>
          </div>
          
        <table style="border:none;" width="100%">
            <tbody>
            <tr>
                <td style="border: none; " width="75%" >
                    <div class="per-page-control">
                        <label for="perPage" class="per-page-label">Rekod per halaman:</label>
                        <select v-model="perPage" @change="changePerPage" id="perPage" class="per-page-select">
                            <option v-for="opt in perPageOptions" :key="opt" :value="opt">
                               {{ opt }}
                            </option>
                        </select>
                    </div>
                </td>
                <td style="border: none; " width="25%"  align="right">
                    <nav class="pagination">
                        <button class="pagination-btn" :disabled="!items.prev_page_url" @click="paginate(items.prev_page_url)">
                            Sebelumnya
                        </button>
                        <span class="pagination-info">
                            {{ items.current_page }} dari {{ items.last_page }}
                        </span>

                        <button class="pagination-btn" :disabled="!items.next_page_url" @click="paginate(items.next_page_url)">
                            Seterusnya
                        </button>
                    </nav>
                </td>
            </tr>
            </tbody>
        </table>
        </w-card>

       <!--   <z-table title="Senarai Permohonan Baka" :headers="table.headers" :items="table.items" :meta="table.meta" :mobile-breakpoint="700">
         </z-table>
 -->
        <br>
        <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'BILANGAN BSE'">
            <template #title>
                BILANGAN BSE
            </template>
            <div class="trend-grid">
                <div class="trend-box">
                 <!-- <div class="w-card__content content-hardcode mb3"> -->
                    <w-form ref="form_chart" v-model="form_chart.valid" @validate="validateFormChart" @success="success">
                        <w-flex class="mt3">
                           
                           <z-select style="margin:5px; " v-model="form_chart.jenis_graf"
                              :items="[
                                 { value: 1, label: 'PIE' },
                                 { value: 2, label: 'BAR' },
                                 { value: 3, label: 'LINE BAR' },
                              ]"
                              label="Jenis Graf"
                              :validators="[validators.required]"
                           />
                           <z-select style="margin:5px; " v-model="form_chart.exis_x"
                              :items="itemsX"
                              label="Axis X"
                              :validators="[validators.required]"
                           />
                           <z-select style="margin:5px; " v-model="form_chart.exis_y"
                              :items="itemsY"
                              label="Axis Y"
                              :validators="[validators.required]"
                           />
                           &nbsp;
                           <w-input label="Tajuk" v-model="form_chart.tajuk" :validators="[validators.required]"/>
                        </w-flex>  

                        <w-flex class="mt3" >
                           
                            <div class="filter-col" v-if="$zutil.role('1')">
                                <w-select class="mt4 role-selector" :items="negeri" v-model="form_chart.lkp_negeri_id"  label="Negeri" placeholder="-----SEMUA-----" outlined color="primary" large dark v-if="$zutil.role('1') && form_chart.exis_x == 4" />
                            </div>
                        </w-flex> 
                     </w-form>
                     <br>
                        <w-flex justify-end class="mt2">

                            <w-button class="ml1" :loading="form_chart.loading" @click="$refs.form_chart.validate()">JANA</w-button>
                            
                        </w-flex>
                        <br>
                        <br>
                        <w-flex justify-end class="mt2">
                            <w-button class="ml1" :disabled="!chart_data || chart_data.length <= 1" @click="downloadChart">JANA GRAF (PNG)</w-button>
                            
                        </w-flex>
                        <br>
                        <br>
                    <!-- </div> -->
                </div>

                <div class="trend-box">

                    <template v-if="chart_jenis == 1">
                        <GChart 
                        type="PieChart" 
                        :data="chart_data" 
                        :options="{ title: chart_title , legend: { position: 'right' },  width: 1250,
                        height: 575, }"
                        ref="gchart"
                        @ready="onChartReady"/>
                    </template>

                    <template v-else-if="chart_jenis == 2">
                        <GChart 
                        type="ColumnChart" 
                        :data="chart_data" 
                        :options="{ title: chart_title, legend: { position: 'right' },  width: 1250,
                        height: 575, }"
                        ref="gchart"
                        @ready="onChartReady"/>
                    </template>

                    <template v-else-if="chart_jenis == 3">
                        <GChart
                        type="LineChart"
                        :data="chart_data"
                        :options="{
                        title: chart_title,
                        curveType: 'function',
                        legend: { position: 'bottom' },
                        chartArea: { left: 50, right: 20, top: 40, bottom: 60 },
                            vAxis: {
                                viewWindow: { min: 0 },
                                format: '0'
                            }
                        }"
                        ref="gchart"
                        @ready="onChartReady"
                        />
                    </template>
                    <template v-else>
                        <br><br><br><br><br>
                        <br><br><br><br><br>
                        <br><br><br><br><br>
                        
                    </template>
                </div>
            </div>
        </w-card>

      </div>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import { GChart } from "vue-google-charts";

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
    negeri_user: [Array, Object],
    segmenName: [Array, Object]
  },
   components: {
        GChart
    },
  data() {
    return {
      resourceurl: 'laporan.kelahiran'+this.segmenName,
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Laporan', route: '/laporan' },
        { label: 'BSE', route: 'laporan/laporan_bse' },
      ],
      // perPage: this.$page.props.items?.per_page || 1,
      form : this.datas,
     

      pencarian: {
         lkp_negeri_id: '',
         lkp_bandar_id: '',
         lkp_daerah_id: '',
         premis_id: '',
         lkp_tujuan_id: '',
         lkp_ternakan_id: '',
         tarikh_dari: '',
         tarikh_hingga: '',
      },

      form_chart: {
         jenis_graf: '',
         exis_x: '',
         exis_y: '',
         tajuk: '',
         lkp_negeri_id: '',
         loading:false,
      },

      chart_data : [],
      chart_title: '',
      chart_jenis: '',
       
      premis: [],
      negeri:[],
      bandar:[],
      daerah:[],
      lkp_tujuan : [],
      lkp_ternakan : [],
      perPageOptions: [5, 10, 50, 99],
      perPage: this.items.per_page || 10,

      chartReady: false,
      chartInstance: null,
      
      
    }
  },
  methods: {
   paginate(url) {
        let params = {
            ...this.pencarian,
        };

        this.$inertia.get(url, params, {
            preserveState: true,
            preserveScroll: true,
        });
    },
   
   cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       params.per_page = this.perPage;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },

  
   getNegeri() {
     this.$zcomm.get(this.api_service + 'lookup/negeri_user', {}).then(res => {
       this.negeri = res

       // kalau hanya ada 1 negeri (role 4), langsung set default
       if (this.negeri.length === 1) {
         this.selectedNegeri = this.negeri[0].value
         // this.getBandar(this.selectedNegeri)
         this.getDaerah(this.selectedNegeri)
       }
     })
   },

   getDaerah(i){
        this.pencarian.lkp_daerah_id = null
        this.$zcomm.get(this.api_service + 'lookup/daerah/'+i, {}).then(res => {
          this.daerah = res
        })
    },

    getBandar(i){
        this.$zcomm.get(this.api_service + 'lookup/bandar/'+i, {}).then(res => {
            this.bandar = res
        })
    },

    getPremis(){
       this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
            this.premis = res
       })
    },
    getTernakan(){
         this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
           this.lkp_ternakan = res
         })
       },


    getTujuan(){
      this.$zcomm.get(this.api_service + 'lookup/tujuan', {}).then(res => {
        this.lkp_tujuan = res
      })
    },
    


   createExcel() {
      const params = {
         lkp_negeri_id: this.pencarian.lkp_negeri_id || '',
         lkp_daerah_id: this.pencarian.lkp_daerah_id || '',
         lkp_bandar_id: this.pencarian.lkp_bandar_id || '',
         premis_id: this.pencarian.premis_id || '',
         lkp_ternakan_id: this.pencarian.lkp_ternakan_id || '',
         lkp_tujuan_id: this.pencarian.lkp_tujuan_id || '',
         tarikh_dari: this.pencarian.tarikh_dari || '',
         tarikh_hingga: this.pencarian.tarikh_hingga || '',
         // per_page: this.perPage || 10,
         excel: 1 // penanda untuk generate Excel
      };
      const queryString = new URLSearchParams(params).toString();
      const url = route('laporan.laporan_bse') + '?' + queryString;
      window.open(url, '_blank');

    // const url = route('laporan.service.service_ai') + '?' + new URLSearchParams(params).toString();
    // window.open(url, '_blank');
   },

  changePerPage() {
        let params = {
            ...this.pencarian,
            per_page: this.perPage,
            page: 1
        };
        this.$inertia.visit(route(route().current(), params), {
            preserveState: true,
            preserveScroll: true,
        });
    },


    validateFormChart() {
      this.loading=true;
      let isValid = true;
         
      if(!this.form_chart.jenis_graf ||  !this.form_chart.exis_x || !this.form_chart.exis_y || !this.form_chart.tajuk){
         isValid = false;
      }
      if (!isValid) {
        this.$zutil.notify("Pastikan data sudah terisi", false);
        this.loading=false;
        return false;
      }
      // this.datas.hantar = 1;
      this.getChart();
    },


    getChart(){
        this.$zcomm.get('laporan.chart_bse', {jenis_graf:this.form_chart.jenis_graf, exis_x:this.form_chart.exis_x, exis_y:this.form_chart.exis_y, tajuk:this.form_chart.tajuk, lkp_negeri_id:this.form_chart.lkp_negeri_id}).then(res => {
            // Format ulang data untuk Google Chart
            let datas = [["Nama", "Jumlah"]]; // header wajib
            if (res.length > 0 && res[0].datas) {
                res[0].datas.forEach(item => {
                    datas.push([item.nama, parseInt(item.jumlah) || 0]);
                });
            }
            this.chart_data = datas;
            this.chart_title = res[0].tajuk;
            this.chart_jenis = res[0].jenis_graf;
        });
    },
    
    onChartReady(chart, google) {
        this.chartInstance = chart; 
        this.chartReady = true;
    },

    downloadChart() {
        if (!this.chartReady || !this.chartInstance) {
            alert('Carta belum dijana sepenuhnya');
            return;
        }
        // const imageURI = this.chartInstance.getImageURI();
        const imageURI = this.chartInstance.getImageURI({
            width: 2000,
            height: 1200
        });

        const link = document.createElement('a');
        link.href = imageURI;
        link.download = (this.chart_title || 'chart') + '.png';
        link.click();
    },

  },

  watch: {

  },

  computed: {
    itemsX() {
        let items = [];

        if (this.$zutil.anyRole(['2'])) {
            items.unshift(
                { value: 1, label: 'Premis' },
                { value: 2, label: 'Tujuan BSE' },
                { value: 3, label: 'Jenis Ternakan' },
                { value: 6, label: 'Baka' }
            );
        }else if(this.$zutil.anyRole(['4'])){
            items.unshift(
                { value: 2, label: 'Tujuan BSE' },
                { value: 3, label: 'Jenis Ternakan' },
                { value: 4, label: 'Daerah' },
                { value: 5, label: 'Negeri' },
                { value: 6, label: 'Baka' }
            );
        }else if(this.$zutil.anyRole(['1'])){
            items.unshift(
                { value: 2, label: 'Tujuan BSE' },
                { value: 3, label: 'Jenis Ternakan' },
                { value: 4, label: 'Daerah' },
                { value: 5, label: 'Negeri' },
                { value: 6, label: 'Baka' }
            );
        }else{
            items.unshift(
                { value: 1, label: 'Premis' },
                { value: 2, label: 'Tujuan BSE' },
                { value: 3, label: 'Jenis Ternakan' },
                { value: 4, label: 'Daerah' },
                { value: 5, label: 'Negeri' },
                { value: 6, label: 'Baka' }
            );
        }
        return items;
    },
    

    itemsY() {
        let items = [];

        
            items.unshift(
               { value: 1, label: 'Count Bil BSE' }
            );
        return items;
    }
  },

  mounted() {
   this.getNegeri(); 
   this.getPremis();
   this.getTernakan();
   this.getTujuan();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>

<style>
.pagination {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
}

.pagination-btn {
  background-color: #007bff;
  color: white;
  padding: 5px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.pagination-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pagination-info {
  font-weight: bold;
}

.per-page-control {
  display: flex;
  align-items: center;
  gap: 8px;
}

.per-page-label {
  font-weight: 500;
  font-size: 14px;
  color: #333;
}

.per-page-select {
  padding: 5px 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 14px;
  background-color: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
}

.per-page-select:hover {
  border-color: #007bff;
  box-shadow: 0 0 4px rgba(0, 123, 255, 0.4);
}

.w-table thead tr:nth-child(1) th {
  position: sticky;
  top: 2px;
  background: #fff;
  z-index: 3;
}

/* Header baris kedua */
.w-table thead tr:nth-child(2) th {
  position: sticky;
  top: 32px; /* sesuaikan dengan tinggi row pertama */
  background: #fff;
  z-index: 2;
}


.role-selector {
  width: 100%;
  max-width: 400px;
  border: 2px solid #1976d2;
  border-radius: 8px;
  background-color: #f5f5f5;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  font-weight: bold;
}

.role-selector .w-select__selection {
  padding: 12px 16px;
  font-size: 16px;
}

.role-selector .w-select__label {
  font-weight: bold;
  color: #1976d2;
}
.filter-row {
  display: flex;
  gap: 10px;
}

.filter-col {
  flex: 1;
  min-width: 220px; /* optional – elak jadi terlalu kecil */
}
</style>
